export const TOAST_MESSAGE = 'TOAST_MESSAGE';
export const TOAST_CLEAR = 'TOAST_CLEAR';

export function toastMessage(message) {
    return {
        type: TOAST_MESSAGE,
        payload: message
    };
}

export function toastClear() {
    return {
        type: TOAST_CLEAR
    };
}



// WEBPACK FOOTER //
// src/actions/toast.js